import { fetchWrapper } from "@/utils/fetchWrapper";
import { protectedResources } from "@/config/authConfig";

import { DynamicsContact } from "@/types/dynamics.types";

export interface RemoveOrganizationData {
  id: string;
  accountId: string;
}

async function getCurrentUser(): Promise<DynamicsContact> {
  const scopes = protectedResources.api.scopes;

  const url = `${process.env.REACT_APP_BASE_URL}/contacts/me`;
  // Use raw response so we can branch on specific status codes
  const response: Response = await fetchWrapper(
    url,
    { method: "GET", returnType: "raw" },
    scopes,
  );

  if (!response.ok) {
    // Delegate other errors to the existing text/json handler by re-fetching via fetchWrapper default
    // This keeps error shape consistent across the app
    const fallback = await fetchWrapper<DynamicsContact>(
      url,
      { method: "GET" },
      scopes,
    );
    return fallback; // will actually throw above if non-ok
  }

  // Success path
  const result = (await response.json()) as DynamicsContact;
  return result;
}

async function updateUserData(
  data: Partial<DynamicsContact>,
): Promise<DynamicsContact> {
  const scopes = protectedResources.api.scopes;

  const url = `${process.env.REACT_APP_BASE_URL}/contacts/me`;
  return fetchWrapper<DynamicsContact>(
    url,
    { method: "PATCH", body: JSON.stringify(data) },
    scopes,
  );
}

async function assignDirector(
  users: { ContactId: string; IsDirector: boolean }[],
  accountId: string,
) {
  const scopes = protectedResources.api.scopes;

  const url = `${process.env.REACT_APP_BASE_URL}/contacts?accountId=${accountId}`;

  const result = await fetchWrapper(
    url,
    { method: "PATCH", body: JSON.stringify(users) },
    scopes,
  );

  return result;
}

async function removeOrganization(requestData: RemoveOrganizationData) {
  const scopes = protectedResources.api.scopes;

  const url = `${process.env.REACT_APP_BASE_URL}/contacts/${requestData.id}/organization?accountId=${requestData.accountId}`;

  const result = await fetchWrapper(
    url,
    { method: "DELETE", body: JSON.stringify(requestData) },
    scopes,
  );

  return result;
}

async function getPaymentHistory() {
  const scopes = protectedResources.api.scopes;

  const url = `${process.env.REACT_APP_BASE_URL}/contacts/paymenthistory`;
  const result = await fetchWrapper(url, { method: "GET" }, scopes);

  return result;
}

export {
  getCurrentUser,
  updateUserData,
  assignDirector,
  removeOrganization,
  getPaymentHistory,
};
